import  {GET_INVENTORY_DETAIL} from "../constants/actionTypes";
import * as api from "../api/index.js";

export const getInventoryDetail = (formData) => async (dispatch) => {
  try {
    const response = await api.getInventoryDetail(formData);
    dispatch({
      type: GET_INVENTORY_DETAIL,
      payload: response.data?.content,
    });
  } catch (error) {
    console.error("GET_INVENTORY_DETAIL error", error);
  }
};
